import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EvCore } from 'ev-core';
import { INewDwellingProjectData } from 'src/app/infopage/new-new-dwelling/newdwelling.model';
import { EvProgressBarComponent } from 'src/app/shared-components/ev-progress-bar/ev-progress-bar.component';
import { buildProjectTotals, buildStageTotals } from 'src/app/infopage/new-new-dwelling/components/project-stages/project-stages.util';
import { DatePipe } from '@angular/common';
import { EVNDSaleStateType } from 'src/models/new-dwelling/new-dwelling.enums';

@Component({
    selector: 'project-stages-compact',
    templateUrl: './project-stages-compact.component.html',
    styleUrl: './project-stages-compact.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe, DatePipe, EvCore, EvProgressBarComponent],
})
export class ProjectStagesCompactComponent {
    readonly EVNDSaleStateType = EVNDSaleStateType;

    projectData = input<INewDwellingProjectData>();
    selectedProjectStage = input<number>();

    projectInfo = computed(() => this.projectData()?.projectInfo);
    projectTotals = computed(() => buildProjectTotals(this.projectData()));
    stages = computed(() => buildStageTotals(this.projectData(), this.selectedProjectStage()));
    stageMode = computed(() => this.selectedProjectStage() != null && this.selectedProjectStage() > 0);
}
